import React from 'react';
import {
  Button,
} from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const UserRoleFilter = ({
  matches,
  onClick,
  name,
  floated,
}) => {
  const intl = useIntl();
  return (
    <Button
      size="mini"
      basic
      icon={matches ? 'cancel' : 'filter'}
      floated={floated}
      title={intl.formatMessage({ id: matches ? 'actions.clear.current.filter' : 'roles.current.filter' })}
      onClick={() => onClick(matches ? null : name)}
    />
  );
};

export default UserRoleFilter;
